import { render, staticRenderFns } from "./SectionItemEdit.vue?vue&type=template&id=35f589a4&scoped=true&"
import script from "./SectionItemEdit.vue?vue&type=script&lang=js&"
export * from "./SectionItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./SectionItemEdit.vue?vue&type=style&index=0&id=35f589a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f589a4",
  null
  
)

export default component.exports